module.exports = __webpack_public_path__ + "img/Pioneer-Dashboard.3b65fa5e.jpg";